/**
 * Tracker-scoped wrapper around {@link useResourcePresence}.
 */

import { useCallback, useMemo } from 'react';
import { useResourcePresence } from '@/hooks/useResourcePresence';

export interface UseTrackerPresenceReturn {
  presenceByRow: ReturnType<typeof useResourcePresence>['presenceByRow'];
  setActiveRow: (rowId: string | null) => void;
}

export function useTrackerPresence(): UseTrackerPresenceReturn {
  const { presenceByRow, setActiveRow } = useResourcePresence();

  const setTrackerRow = useCallback(
    (rowId: string | null) => {
      setActiveRow(
        rowId ? { rowId, scope: 'tracker', subjectResourceType: 'ServiceRequest' } : null,
      );
    },
    [setActiveRow],
  );

  return useMemo(
    () => ({ presenceByRow, setActiveRow: setTrackerRow }),
    [presenceByRow, setTrackerRow],
  );
}
